import O1HD from "../../../../engines/gameEngine";
import NormalGameManager from "../../manager/NormalGameManager";
import {NestCacheEntity} from "../../manager/DefineInterface";

const {ccclass, property} = cc._decorator;

/**
 * 鸡窝
 */
@ccclass
export default class NestNode extends cc.Component {

    @property(cc.Label)
    eggCount : cc.Label = null;
    @property(cc.Node)
    eggIconNode : cc.Node = null;
    @property
    goodsId : number = 0;
    @property(cc.Node)
    touchNode : cc.Node = null;

    //鸡槽 缓存数据
    private nestCacheData : NestCacheEntity;
    private tempEggNode : cc.Node;

    onLoad () {
        O1HD.on("NestNode.addEggs" , this.addEggs , this );
    }

    start () {
        this.initData();
        this.touchNode.on("touchstart" , this.touchStart , this );
        this.touchNode.on("touchmove" , this.touchMove , this );
        this.touchNode.on("touchcancel" , this.touchCancel , this );
        this.touchNode.on("touchend" , this.touchEnd , this );
    }


    touchStart( e : cc.Event.EventTouch ){
        if ( !this.tempEggNode && this.nestCacheData.count > 0 ) {
            this.tempEggNode = cc.instantiate( this.eggIconNode );
            this.node.addChild( this.tempEggNode );
            if ( this.nestCacheData.count == 1 ) {
                this.eggIconNode.active = false;
            }
        }
    }

    touchMove( e : cc.Event.EventTouch ){
        if ( this.tempEggNode ){
            this.tempEggNode.x += e.getDeltaX();
            this.tempEggNode.y += e.getDeltaY();
        }
    }
    touchCancel( e : cc.Event.EventTouch ){
        let pos = this.tempEggNode.convertToWorldSpaceAR(cc.v2());
        O1HD.emit("HatchingBinNode.checkEnterEgg" , pos , this.nestCacheData.goodsId , ( ret : boolean )=>{
            if ( ret ) {
                console.log("true")
                // 鸡蛋移除
                this.nestCacheData.count --;
                if ( this.nestCacheData.count == 0 ) {
                    this.eggIconNode.active = false;
                }else{
                    this.eggIconNode.active = true;
                }
                NormalGameManager._instance.writeGameData();
                this.refreshData();
            }else{
                console.log("false")
                this.eggIconNode.active = true;
            }
        });
        this.tempEggNode.removeFromParent();
        this.tempEggNode.destroy();
        this.tempEggNode = null;
    }
    touchEnd( e : cc.Event.EventTouch ){
        this.tempEggNode.removeFromParent();
        this.tempEggNode.destroy();
        this.tempEggNode = null;
        // 收蛋
        if( this.nestCacheData.count && this.nestCacheData.count != 0 ) {
            NormalGameManager._instance.onPushGoods( this.nestCacheData.goodsId , this.nestCacheData.count );
            let worldPos = this.node.convertToWorldSpaceAR(cc.v2());
            O1HD.getManagers().gameMgr.addGoodsEffect( this.nestCacheData.count , cc.v2(worldPos.x ,worldPos.y + 50 ) );
            this.nestCacheData.count = 0;
            this.refreshData();
        }
    }

    initData(){
        this.nestCacheData = NormalGameManager._instance.getGameData().chickenCoop.nestData.find(( item ,index ,datalist )=>{
            return item.goodsId == this.goodsId;
        });
        if ( !this.nestCacheData ) {
            this.nestCacheData = { goodsId : this.goodsId , count : 0 };
            NormalGameManager._instance.getGameData().chickenCoop.nestData.push( this.nestCacheData );
        }else{
            this.refreshData();
        }
    }

    refreshData(){
        if ( this.nestCacheData.count != 0 ) {
            this.eggIconNode.active = true;
            this.eggCount.node.active = true;
            this.eggCount.string = `${this.nestCacheData.count}`;
        }else{
            this.eggIconNode.active = false;
            this.eggCount.node.active = false;
        }
    }

    /**
     * 添加鸡蛋
     * @param eggId
     */
    addEggs( eggId : number ){
        if ( eggId == this.goodsId ) {
            this.eggIconNode.active = true;
            this.eggCount.node.active = true;
            this.eggCount.string = `${++this.nestCacheData.count}`;
            NormalGameManager._instance.writeGameData();
        }
    }

    /**
     * 收集
     */
    onBtnCollect(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        //TODO 收蛋动画

    }

}
